<script>
    // @ts-nocheck
    import Frame from '$lib/components/layout/Frame.svelte'
    import { Form, Button, Spinner, Alert } from '$lib/components/UI/'
    import Track from '$lib/components/UI/Track.svelte'
    import { scale } from 'svelte/transition'
    import { API_URL } from '$lib/conf'
    import DatosProveedor from '$lib/components/forms/DatosProveedor.svelte'
    import InformacionImpositiva from '$lib/components/forms/InformacionImpositiva.svelte'
    import Result from '$lib/components/UI/Result.svelte'
    import InformacionLaboral from '$lib/components/forms/InformacionLaboral.svelte'
    import AcreditacionCuenta from '$lib/components/forms/AcreditacionCuenta.svelte'
    import Typography from '$lib/components/UI/Typography.svelte'
    import { navigate } from 'svelte-navigator'
    export let uuid
    let formData
    let validForm
    let current
    let blockButton = false
    let state
    let data = {}
    const fetchData = fetch(`${API_URL}/status/${uuid}`)
        .then(async (res) => {
            if (res.ok) {
                let ret = await res.json()
                console.log(ret)
                data = ret.update
                state = ret.state
                if (ret.type == 'siniestros') {
                    navigate(`/alta/status_sin/${uuid}`, { replace: true })
                }
                return ret
            } else {
                throw Error('404')
            }
        })
        .catch((e) => {
            throw Error('404')
        })

    function sendData() {
        blockButton = true
        fetch(`${API_URL}/provider/${uuid}`, {
            method: 'PUT',
            body: JSON.stringify(formData),
        })
            .then((res) => {
                if (res.ok) {
                    navigate('/result', {
                        state: {
                            title: '¡Listo!',
                            desc: 'Se modificó correctamente su información.',
                            icon: 'mailPositive',
                        },
                    })
                }
            })
            .catch((err) => {
                blockButton = false
            })
    }
    const states = [
        {
            label: 'Validación de datos',
            states: [
                'Ingresado',
                'Mesa Proveedores',
                'Control de Gestion',
                'Compras',
                'Cuentas a Pagar',
                'Solicitud de Informacion Compras',
                'Solicitud de Informacion Cuentas a Pagar',
                'Impuestos',
            ],
            desc: 'Estamos validando tus datos. Pronto recibirá un mail confirmando su habilitación.',
        },
        {
            label: 'Validación info. impositiva',
            states: [
                'Tesoreria',
                'Impuestos',
                'Solicitud de Informacion Tesoreria',
                'Solicitud Impuestos Prov',
                'Solicitud Control de Gestion Prov',
                'Revision Mesa Proveedores CG',
                'Revision Mesa Proveedores IMP',
                'Revision Mesa Proveedores TES',
                'Solicitud Informacion Prov',
                'Solicitud Tesoreria Prov',
            ],
            desc: 'Estamos validando sus datos impositivos',
        },
        {
            label: 'Habilitación',
            states: ['Habilitado'],
            desc: 'El proceso de alta finalizó correctamente, por favor verifique su casilla de correo para conocer el resultado.',
        },
    ]
    $: if (state)
        current = (function () {
            let res = 0
            states.forEach((st, i) => {
                if (st.states.includes(state)) {
                    res = i
                }
            })
            return res
        })()
    let validForms = {}
</script>

<Frame title="Estado de solicitud">
    <div class="formulario">
        {#await fetchData}
            <div class="space" transition:scale>
                <Spinner />
            </div>
        {:then dataf}
            <Track
                {current}
                breakPoints={states.map((x) => {
                    return { label: x.label }
                })}
            />
            {#if state.match(/^Sol.+/) && dataf.update && Object.keys(dataf.update).length > 0}
                {#if dataf.comment}
                    <Alert style="width: 100%" type="warning"
                        >{@html dataf.comment.replace(
                            /\n|\\n/g,
                            '<br/>'
                        )}</Alert
                    >
                {/if}
                <Form bind:valid={validForm} bind:data={formData}>
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_dp$/) )}
                        <hr />
                        <DatosProveedor
                            bind:valid={validForms.DatosProveedor}
                            inputs={Object.keys(dataf.update)}
                            data={dataf.update}
                        />
                    {/if}
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_ii$/) )}
                        <hr />
                        <InformacionImpositiva
                            bind:valid={validForms.InformacionImpositiva}
                            inputs={Object.keys(dataf.update)}
                            data={dataf.update}
                        />
                    {/if}
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_lp$/) )}
                        <hr />
                        <InformacionLaboral
                            bind:valid={validForms.InformacionLaboral}
                            inputs={Object.keys(dataf.update)}
                            data={dataf.update}
                        />
                    {/if}
                    {#if Object.keys(dataf.update).some( (x) => x.match(/^.+_ac$/) )}
                        <hr />
                        <AcreditacionCuenta
                            bind:valid={validForms.AcreditacionCuenta}
                            inputs={[...Object.keys(dataf.update)]}
                            data={dataf.update}
                        />
                    {/if}
                    <br />
                    <Button
                        on:click={sendData}
                        disabled={!(!blockButton
                            ? Object.values(validForms).every((x) => x)
                            : false)}
                        label="Enviar información"
                    />
                </Form>
            {:else}
                <Result type="neutral">
                    <Typography style="text-align: center" type="h3"
                        >{states[current].desc}</Typography
                    >
                    <Typography type="body">RequestId: {uuid}</Typography>
                </Result>
            {/if}
        {/await}
    </div>
</Frame>

<style>
    .formulario {
        max-width: 1000px;
        width: 100%;
        position: relative;
        background: var(--color-white);
        padding: 25px;
        margin: auto;
    }
    .space {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }
</style>
